import React from 'react';
import { useTranslation } from 'react-i18next';
import { Field } from 'react-final-form';
import PropTypes from 'prop-types';
import { Unstable_Grid2 as Grid } from '@mui/material';
import ContentEditorFieldAdapter from 'components/shared/field-adapters/ContentEditorFieldAdapter';
import DatePickerFieldAdapter from 'components/shared/field-adapters/DatePickerFieldAdapter';
import ImageUploadAdapter from 'components/shared/field-adapters/ImageUploadAdapter';
import SelectFieldAdapter from 'components/shared/field-adapters/SelectFieldAdapter';
import TextFieldAdapter from 'components/shared/field-adapters/TextFieldAdapter';
import { getUiLanguageOptions } from 'common/constants/options';
import { isRequiredField } from 'common/utils/general';

function NewsFields({ requiredFields }) {
  const { t } = useTranslation(['labels']);

  return (
    <Grid container spacing={4}>
      <Grid xs={12}>
        <Field
          id="title"
          name="title"
          component={TextFieldAdapter}
          label={t('title', { ns: 'labels' })}
          helperText={t('newsTitleHelp', {
            ns: 'labels',
            defaultValue:
              'Admite letras, números, espacios y signos como & . , : ! ? ( ) -. No se permiten < ni >'
          })}
          type="text"
          fullWidth
          required={isRequiredField('title', requiredFields)}
        />
      </Grid>
      <Grid xs={12}>
        <Field
          id="summary"
          name="summary"
          component={TextFieldAdapter}
          label={t('newsSummary', { ns: 'labels', defaultValue: 'Resumen (gancho de la card)' })}
          helperText={t('newsSummaryHelp', {
            ns: 'labels',
            defaultValue: 'Máximo 220 caracteres. Si lo dejas vacío se genera del primer párrafo.'
          })}
          type="text"
          multiline
          minRows={2}
          inputProps={{ maxLength: 220 }}
          fullWidth
        />
      </Grid>
      <Grid xs={12}>
        <Field
          id="body"
          name="body"
          component={ContentEditorFieldAdapter}
          label={t('body', { ns: 'labels' })}
          required={isRequiredField('body', requiredFields)}
        />
      </Grid>
      {/* Una sola imagen destacada; se adapta a mobile/desktop por CSS en la vista. */}
      <Grid xs={12} md={6}>
        <Field
          id="featured_image"
          name="featured_image"
          component={ImageUploadAdapter}
          label={`${t('featuredImage', { ns: 'labels' })} · JPG, PNG · ${t('aspect16by9Hint', { ns: 'labels', defaultValue: 'Relación 16:9 (ej. 1280×720)' })}`}
          allowedFileTypes={{
            'image/png': ['.png'],
            'image/jpeg': ['.jpg', '.jpeg']
          }}
          crop
          cropAspect={16 / 9}
          cropShape="rect"
        />
      </Grid>
      <Grid xs={12} sm={6}>
        <Field
          id="created_at"
          name="created_at"
          component={DatePickerFieldAdapter}
          label={t('createdAt', { ns: 'labels' })}
          renderInputProps={{
            fullWidth: true,
            required: isRequiredField('created_at', requiredFields)
          }}
        />
      </Grid>
      <Grid xs={12} sm={6}>
        <Field
          id="language"
          name="language"
          component={SelectFieldAdapter}
          options={getUiLanguageOptions(t)}
          label={t('language', { count: 1, ns: 'labels' })}
          fullWidth
        />
      </Grid>
    </Grid>
  );
}

NewsFields.propTypes = {
  requiredFields: PropTypes.arrayOf(PropTypes.string).isRequired
};

export default NewsFields;
